<template>
  <div class="pad">
    <div
      class="wrap"
      style="background-color: white; z-index: 5; width: 100vw; position: fixed"
    >
      <div style="display: flex; justify-content: space-between">
        <div class="nav_content">
          <div>
            <span
              class="title1"
              style="width: 150px"
              v-if="$route.params.id == 1"
              >NZONE S7 Pro</span
            >
            <span
              class="title1"
              style="width: 250px"
              v-else-if="$route.params.id == 2"
              >NZONE S7 Pro+ 5G</span
            >
            <span class="title1" style="width:250px" v-else-if="$route.params.id == 3">NZONE S7</span>
            <span class="title1" style="width:250px" v-else-if="$route.params.id == 4">NZONE 50 Pro</span>
          </div>

          <div class="change" style="margin-left: 35vw">
            <template v-if="showDetails == true">
              <a class="title_checked" style="width: 100px; margin-top: 5px"
                >功能特征</a
              >
              <a
                class="title"
                style="
                  margin-left: 3vw;
                  margin-right: 2vw;
                  width: 100px;
                  margin-top: 5px;
                "
                @click="changePage1"
                >规格参数</a
              >
            </template>

            <template v-else>
              <a
                class="title"
                style="width: 100px; margin-top: 5px"
                @click="changePage"
                >功能特征</a
              >
              <a
                class="title_checked"
                style="
                  margin-left: 3vw;
                  margin-right: 2vw;
                  width: 100px;
                  margin-top: 5px;
                "
                >规格参数</a
              >
            </template>

            <div class="buy">
              <button class="buy_button">购买</button>

              <div class="menu">
                <div style="" class="showing">
                  <!-- <div class="mobile">
                    <div
                      class="flex"
                      @click="
                        change3;
                        openshop(
                          'https://touch.10086.cn/appregion.html?backUrl=http%3A%2F%2Ftouch.10086.cn%2Fgoods%2F%7Bprovince%7D_%7Bcity%7D_1085328_1073664.html'
                        );
                      "
                    >
                      <img
                        src="../assets/images/mobileshop.png"
                        style="width: 30px"
                      />
                      <span class="buy_content">移动商城</span>
                      <i
                        style="margin-left: 10px; color: transparent"
                        class="el-icon-arrow-down"
                      ></i>
                    </div>
                  </div> -->
                  <div class="flex" @click="change1">
                    <img
                      src="../assets/images/jdshop.png"
                      style="width: 30px"
                    />
                    <span class="buy_content">京东商城</span>
                    <i
                      v-if="show1"
                      style="margin-left: 10px; color: black; font-size: 16px"
                      class="el-icon-arrow-down"
                    ></i>
                    <i
                      v-if="!show1"
                      style="margin-left: 10px; color: black; font-size: 16px"
                      class="el-icon-arrow-right"
                    ></i>
                  </div>
                  <div v-if="show1">
                    <div
                      class="flex1"
                      v-if="$route.params.id == 1"
                      @click="openshop('https://item.jd.com/100015461303.html')"
                    >
                      <span class="buy_content1">京东旗舰店</span>
                    </div>

                    <div
                      class="flex1"
                      v-else-if="$route.params.id == 2"
                      @click="openshop('https://item.jd.com/100028335810.html')"
                    >
                      <span class="buy_content1">京东旗舰店</span>
                    </div>

                    <div
                      class="flex1"
                      v-else-if="$route.params.id == 3"
                      @click="openshop('https://item.jd.com/100031844120.html')"
                    >
                      <span class="buy_content1">京东旗舰店</span>
                    </div>
                    <div
                      class="flex1"
                      v-if="$route.params.id == 1"
                      @click="openshop('https://item.jd.com/100012099371.html')"
                    >
                      <span class="buy_content1">京东自营店</span>
                    </div>

                    <div
                      class="flex1"
                      v-else-if="$route.params.id == 2"
                      @click="openshop('https://item.jd.com/100013406191.html')"
                    >
                      <span class="buy_content1">京东自营店</span>
                    </div>

                    <div
                      class="flex1"
                      v-else-if="$route.params.id == 3"
                      @click="openshop('https://item.jd.com/100031873874.html')"
                    >
                      <span class="buy_content1">京东自营店</span>
                    </div>
                                      <div
                      class="flex1"
                      v-else-if="$route.params.id == 4"
                      @click="openshop('https://item.jd.com/100035742827.html')"
                    >
                      <span class="buy_content1">京东自营店</span>
                    </div>

                    <div
                      class="flex1"
                      v-if="$route.params.id == 1"
                      @click="
                        openshop('https://item.jd.com/10032642814382.html')
                      "
                    >
                      <span class="buy_content1">京东手机店</span>
                    </div>

                    <div
                      class="flex1"
                      v-else-if="$route.params.id == 2"
                      @click="
                        openshop('https://item.jd.com/10035414846580.html')
                      "
                    >
                      <span class="buy_content1">京东手机店</span>
                    </div>
                  </div>
                  <div class="flex" @click="change2">
                    <img
                      src="../assets/images/tianmaoshop.png"
                      style="width: 30px"
                    />
                    <span class="buy_content">天猫商城</span>
                    <i
                      v-if="show2"
                      style="margin-left: 10px; color: black; font-size: 16px"
                      class="el-icon-arrow-down"
                    ></i>
                    <i
                      v-if="!show2"
                      style="margin-left: 10px; color: black; font-size: 16px"
                      class="el-icon-arrow-right"
                    ></i>
                  </div>

                  <div v-if="show2">
                    <div
                      class="flex1"
                      v-if="$route.params.id == 1"
                      @click="
                        openshop(
                          'https://detail.tmall.com/item.htm?spm=a212k0.12153887.0.0.4d7c687dIAKE3X&id=649462819803'
                        )
                      "
                    >
                      <span class="buy_content1">天猫官方店</span>
                    </div>

                    <div
                      class="flex1"
                      v-else-if="$route.params.id == 2"
                      @click="
                        openshop(
                          'https://detail.tmall.com/item.htm?id=652909457345&sku_properties=5919063:6536025'
                        )
                      "
                    >
                      <span class="buy_content1">天猫官方店</span>
                    </div>

                    <div
                      class="flex1"
                      v-if="$route.params.id == 1"
                      @click="
                        openshop(
                          'https://detail.tmall.com/item.htm?id=649542591594&sku_properties=5919063:6536025'
                        )
                      "
                    >
                      <span class="buy_content1">天猫手机店</span>
                    </div>

                    <div
                      class="flex1"
                      v-else-if="$route.params.id == 2"
                      @click="openshop('https://m.tb.cn/h.fbvTC6L?sm=54602c')"
                    >
                      <span class="buy_content1">天猫手机店</span>
                    </div>

                    <div
                      class="flex1"
                      v-else-if="$route.params.id == 3"
                      @click="openshop('https://m.tb.cn/h.fQwTdoI?sm=cc8c44')"
                    >
                      <span class="buy_content1">天猫官方店</span>
                    </div>
                  </div>
                </div>

                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-divider style="margin-top: -2px; z-index: -1"></el-divider>

    <div v-if="showDetails == true">
      <div v-for="item in detailList" :key="item" style="margin-top: 100px">
        <img :src="item.src" style="width: 100%" />
      </div>
    </div>

    <div v-if="showDetails == false" style="margin-top: 150px">
      <div class="wrap">
        <el-divider style="width: 1250px"></el-divider>
      </div>
      <div class="wrap">
        <div class="wrap1" style="width: 1250px">
          <span class="title5">硬件参数</span>
        </div>
      </div>
      <div class="wrap">
        <div class="box">
          <span class="title3" style="flex-shrink: 0">颜色</span>

          <div
            class="show1"
            style="width: 800px; justify-content: space-between"
          >
            <div style="display: block" v-for="img in imgList" :key="img.name">
              <div style="display: flex; justify-content: center">
                <img :src="img.url" style="width: 150px;max-height:330px" />
              </div>
              <div style="text-align: center; margin-top: 20px">
                <span class="color" style="">{{ img.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="wrap">
                <el-divider style="width:1250px"></el-divider>

            </div> -->

      <template v-if="$route.params.id != 5">
        <div class="wrap">
          <div class="box">
            <span class="title3" style="flex-shrink: 0">外观</span>
            <div class="show1">
              <div style="width: 220px; flex-shrink: 0">
                <!-- <span class="content_title">外观设计</span><br><br>
              <span class="content">直板</span><br><br><br><br>
              <span class="content_title">机身颜色</span><br><br>
              <span class="content">优雅黑、金色阳光、烟雨青蓝</span><br><br><br><br>
              <span class="content_title">电池类型</span><br><br>
              <span class="content">锂聚合物电池</span> -->
                <!-- <span class="content">{{phonelist.params.hardware.appearence[0].name}}</span> -->
                <div
                  v-for="item in phonelist.params.hardware.appearence.left"
                  :key="item"
                >
                  <span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <span class="content">{{ item.value }}</span>
                  <span class="content">{{ item.note }}</span
                  ><br /><br /><br /><br />
                </div>
              </div>
              <div style="margin-left: 130px; width: 450px">
                <div
                  v-for="item in phonelist.params.hardware.appearence.right"
                  :key="item"
                >
                  <span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <span class="content">{{ item.value }}</span>
                  <span class="content">{{ item.note }}</span
                  ><br /><br /><br /><br />
                </div>
                <!-- <span class="content_title">机身尺寸</span><br><br>
              <span class="content">160.68 mm（长）× 73.3 mm（宽）× 8.4 mm（厚）</span><br><br>
              <span class="content1">（备注：实际尺寸依配置、制造工艺、测量方法的不同可能有所差异。）</span><br><br><br><br>
              <span class="content_title">机身重量</span><br><br>
              <span class="content">179g(含电池)</span><br><br>
              <span class="content1">（备注：实际尺寸依配置、制造工艺、测量方法的不同可能有所差异。）</span> -->
              </div>
            </div>
          </div>
        </div>

        <div class="wrap">
          <div class="box">
            <span class="title3">屏幕</span>

            <div>
              <!-- <div style="text-align:left; margin-left:25vw"><span class="title4" style="">显示屏</span></div> -->
              <div class="show1">
                <div style="width: 220px; flex-shrink: 0">
                  <p class="title4" style="margin-top: 0">显示屏</p>
                  <!-- <span class="content_title">屏幕尺寸</span><br><br>
                <span class="content">6.6英寸</span><br><br><br><br>
                <span class="content_title">屏幕材质</span><br><br>
                <span class="content">LTPS</span><br><br><br><br>
                <span class="content_title">屏幕色彩</span><br><br>
                <span class="content">1670万色</span><br><br><br><br><br><br>
                <span class="title4">触摸屏</span><br><br>
                <span class="content">多点触控，最多支持10点触控</span> -->
                  <div
                    v-for="item in phonelist.params.hardware.screen.left"
                    :key="item"
                  >
                    <span class="content_title">{{ item.name }}</span
                    ><br /><br />
                    <span class="content">{{ item.value }}</span
                    ><br /><br /><br /><br />
                  </div>

                  <span class="title4">触摸屏</span><br /><br />
                  <span class="content">{{
                    phonelist.params.hardware.screen.bottom.value
                  }}</span>
                </div>
                <div style="margin-left: 130px; width: 450px; margin-top: 55px">
                  <div
                    v-for="item in phonelist.params.hardware.screen.right"
                    :key="item"
                  >
                    <span class="content_title">{{ item.name }}</span
                    ><br /><br />
                    <span class="content">{{ item.value }}</span
                    ><br /><br /><br /><br />
                  </div>
                  <!-- <span class="content_title">分辨率</span><br><br>
                <span class="content">1080*2400</span><br><br><br><br>
                <span class="content_title">屏幕像素密度</span><br><br>
                <span class="content">339 PPI</span><br><br><br><br>
                <span class="content_title">90Hz刷新率</span><br><br>
                <span class="content">180Hz触控采样率</span><br><br><br><br> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="wrap">
                <el-divider style="width:1250px"></el-divider>

            </div> -->

        <div class="wrap">
          <div class="box">
            <span class="title3">网络</span>
            <div>
              <!-- <div style="text-align:left"><span class="title4">网络制式</span></div> -->
              <div style="display: flex; text-align: left">
                <div style="width: 800px">
                  <div
                    v-for="item in phonelist.params.hardware.network"
                    :key="item"
                  >
                    <span class="title4">{{ item.name }}</span
                    ><br /><br />
                    <div v-for="i in item.value" :key="i">
                      <div v-if="i.title != ''">
                        <span class="content_title">{{ i.title }}</span
                        ><br /><br />
                      </div>
                      <div v-for="j in i.content" :key="j">
                        <span class="content">{{ j }}</span
                        ><br /><br />
                      </div>
                    </div>
                    <span class="note">{{ item.note }}</span
                    ><br /><br /><br /><br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="wrap">
                <el-divider style="width:1250px"></el-divider>

            </div> -->

        <div class="wrap">
          <div class="box">
            <span class="title3" style="">存储</span>
            <div>
              <div style="text-align: left">
                <span class="title4" style="">存储空间</span>
              </div>
              <br /><br />
              <div class="show1">
                <div style="width: 800px">
                  <!-- <span class="content_title">全网通8G+128G版</span><br><br>
                <span class="content">8GB RAM + 128GB ROM</span><br><br><br><br>
                <span class="content_title">全网通8G+256G版</span><br><br>
                <span class="content">8GB RAM + 256GB ROM
                </span><br><br><br><br>
                <span class="content_title">移动版8G+128G版</span><br><br>
                <span class="content">8GB RAM + 128GB ROM</span><br><br><br><br>
                <span class="content1">（备注: 可使用的内存容量小于此值，因为手机软件会占用内存的空间）</span><br><br><br><br>
                <span class="title4">外部存储扩展</span><br><br>
                <span class="content">不支持</span> -->

                  <div
                    v-for="item in phonelist.params.hardware.memory[0].value"
                    :key="item"
                  >
                    <span class="content_title">{{ item.title }}</span
                    ><br /><br />
                    <span class="content">{{ item.value }} </span
                    ><br /><br /><br /><br />
                  </div>
                  <span class="content1">{{
                    phonelist.params.hardware.memory[0].note
                  }}</span
                  ><br /><br /><br /><br />

                  <span class="title4">外部存储扩展</span><br /><br />
                  <span class="content">{{
                    phonelist.params.hardware.memory[1].value
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="wrap">
                <el-divider style="width:1250px"></el-divider>

            </div> -->

        <div class="wrap">
          <div class="box">
            <span class="title3" style="">主体</span>
            <div class="show1">
              <div style="width: 220px; margin-top: -35px">
                <!-- <span class="content_title">CPU型号</span><br><br>
              <span class="content">CPU型号: MediaTek MT6853 5G</span><br><br>
              <span class="content">CPU核数: 八核</span><br><br>
              <span class="content"
                    style="white-space:nowrap">CPU频率: 2xA76 2.0GHz+6xA55 2.0Ghz</span><br><br><br><br>
              <span class="content_title">按键类型</span><br><br>
              <span class="content">电源键+指纹键二合一；音量上键；音量下键；</span> -->
                <div
                  v-for="item in phonelist.params.hardware.base.left"
                  :key="item"
                >
                  <br /><br />
                  <span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <div v-for="i in item.content" :key="i">
                    <span class="content">{{ i }}</span
                    ><br /><br />
                  </div>
                </div>
              </div>
              <div style="margin-left: 130px; width: 450px; margin-top: -35px">
                <div
                  v-for="item in phonelist.params.hardware.base.right"
                  :key="item"
                >
                  <br /><br />
                  <span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <div v-for="i in item.content" :key="i">
                    <span class="content">{{ i }}</span
                    ><br /><br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="wrap">
                <el-divider style="width:1250px"></el-divider>

            </div> -->

        <div class="wrap" v-if="phonelist.params.hardware.transport.left">
          <div class="box">
            <span class="title3" style=""
              >传输<template v-if="prjid == '2'">功能</template>
            </span>
            <div class="show1">
              <div style="width: 220px; margin-top: -35px">
                <div
                  v-for="item in phonelist.params.hardware.transport.left"
                  :key="item"
                >
                  <br /><br /><span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <div v-for="i in item.content" :key="i">
                    <span class="content">{{ i }}</span
                    ><br /><br />
                  </div>
                </div>
                <!-- <span class="content_title">GPS定位</span><br><br>
              <span class="content">GPS</span><br><br>
              <span class="content">AGPS</span><br><br>
              <span class="content"
                    style="white-space:nowrap">Glonass定位</span><br><br>
              <span class="content">北斗定位</span><br><br>
              <span class="content">伽利略</span><br><br><br><br>
              <span class="content_title">WLAN</span><br><br>
              <span class="content">802.11 a/b/g/n/ac 2.4G/5G</span><br><br>
              <span class="content">支持HT20/HT40/HT80
              </span><br><br><br><br>
              <span class="content_title">感应器</span><br><br>
              <span class="content">环境光传感器</span><br><br>
              <span class="content">指南针</span><br><br>
              <span class="content"
                    style="white-space:nowrap">重力传感器</span><br><br>
              <span class="content">指纹传感器</span><br><br>
              <span class="content">陀螺仪</span><br><br><br><br> -->
              </div>
              <div style="margin-left: 130px; width: 450px; margin-top: -35px">
                <!-- <span class="content_title">USB</span><br><br>
              <span class="content">USB 2.0</span><br><br><br><br>
              <span class="content_title">蓝牙</span><br><br>
              <span class="content">BT5.1，支持BLE</span><br><br><br><br>
              <span class="content_title">NFC</span><br><br>
              <span class="content">不支持</span><br><br><br><br> -->
                <div
                  v-for="item in phonelist.params.hardware.transport.right"
                  :key="item"
                >
                  <br /><br /><span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <div v-for="i in item.content" :key="i">
                    <span class="content">{{ i }}</span
                    ><br /><br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="wrap">
                <el-divider style="width:1250px"></el-divider>

            </div> -->

        <div class="wrap">
          <div class="box">
            <span class="title3" style="">其他</span>
            <div>
              <div style="text-align: left">
                <!-- <span class="title4"
                    style="">摄像头</span> -->
              </div>
              <div class="show1">
                <div style="width: 800px; margin-top: -35px">
                  <div
                    v-for="item in phonelist.params.hardware.other"
                    :key="item"
                  >
                    <br /><br /><span class="title4">{{ item.name }}</span
                    ><br /><br />
                    <div v-for="i in item.content" :key="i">
                      <span class="content">{{ i }}</span
                      ><br /><br />
                    </div>
                  </div>
                </div>
                <!-- <div style="width:800px">
                <span class="content">后置摄像头: 6400万像素（F/1.9光圈 AF）+ 800万像素（F/2.4光圈）+ 200万像素(F/2.4光圈，微距)</span><br><br>
                <span class="content">前置摄像头: 1600万像素(F/2.0光圈 FF)</span><br><br><br><br>

                <span class="title4">收音机</span><br><br>
                <span class="content">支持</span><br><br><br><br>

                <span class="title4">电池</span><br><br>
                <span class="content">容量：4000mAh（典型值）</span><br><br>
                <span class="content">理论充电时间：约65min。（本数据为使用标配充电器灭屏充电的实验室数据，实际充电时间，视使用情况而有所不同。）</span><br><br>
                <span class="content">如下数据为实验室数据，实际通话时间、待机时间、上网及双卡待机时间视当地的实际网络情况和使用习惯而有所不同。</span><br><br>
                <span class="content">WCDMA网络制式：理论通话时间最长可达28小时，理论待机时间最长可达534小时。</span><br><br>
                <span class="content">GSM网络制式：理论通话时间最长可达33小时，理论待机时间最长可达435小时。</span><br><br>
                <span class="content">TD-LTE网络制式：理论待机时间最长可达460小时。</span><br><br>
                <span class="content">LTE FDD网络制式：理论待机时间最长可达481小时。</span><br><br>
                <span class="content">NR 网络制式：理论待机时间最长可达360.82小时。</span><br><br><br><br>

                <span class="title4">电源参数</span><br><br>
                <span class="content">输入：100~240V， 50/60Hz,1.2A </span><br><br>
                <span class="content">输出：10V4A MAX</span><br><br><br><br>

                <span class="title4">温度</span><br><br>
                <span class="content">工作温度：0℃～35℃ </span><br><br>
                <span class="content">存储温度：–20℃～+45℃</span><br><br><br><br>

                <span class="title4">工作湿度</span><br><br>
                <span class="content">5% ~ 95%</span><br><br><br><br>

                <span class="title4">认证</span><br><br>
                <span class="content">CTA、无委、BQB、航空运输、移动合作库</span><br><br><br><br>

              </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="wrap">
          <el-divider style="width: 1250px"></el-divider>
        </div>

        <div class="wrap">
          <div class="wrap1" style="width: 1250px">
            <span class="title5">软件参数</span>
          </div>
        </div>

        <div class="wrap">
          <div class="box">
            <span class="title3">主体</span>
            <div class="show1">
              <div style="width: 220px; margin-top: -35px">
                <!-- <span class="content_title">操作系统</span><br><br>
              <span class="content">11.0.1 （基于Android Q开发）</span><br><br><br><br>
              <span class="content_title">用户界面</span><br><br>
              <span class="content">11.0.1</span><br><br><br><br>
              <span class="content_title">浏览器</span><br><br>
              <span class="content">支持</span><br><br><br><br>
              <span class="content_title">输入法</span><br><br>
              <span class="content">百度输入法定制版</span><br><br><br><br> -->
                <div
                  v-for="item in phonelist.params.software.base.left"
                  :key="item"
                >
                  <br /><br /><span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <div v-for="i in item.content" :key="i">
                    <span class="content">{{ i }}</span
                    ><br /><br />
                  </div>
                </div>
              </div>
              <div style="margin-left: 130px; width: 450px; margin-top: -35px">
                <!-- <span class="content_title">LTE语音方案</span><br><br>
              <span class="content">移动：支持CSFB，VoLTE，ViLTE</span><br><br>
              <span class="content">联通：支持CSFB，VoLTE ，ViLTE</span><br><br>
              <span class="content">电信：支持VoLTE，ViLTE</span><br><br>
              <br><br>
              <span class="content_title">语音编解码</span><br><br>
              <span class="content">VoLTE: AMR-WB/AMR-NB</span><br><br>
              <span class="content">WCDMA: AMR-WB</span><br><br>
              <span class="content">GSM: FR/EFR/HR/FR AMR/HR AMR</span><br><br>
              <span class="content">CDMA: 8K EVRC/EVRC-B</span><br><br>
              <br><br> -->
                <div
                  v-for="item in phonelist.params.software.base.right"
                  :key="item"
                >
                  <br /><br /><span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <div v-for="i in item.content" :key="i">
                    <span class="content">{{ i }}</span
                    ><br /><br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="wrap">
                <el-divider style="width:1250px"></el-divider>

            </div> -->

        <div class="wrap">
          <div class="box">
            <span class="title3">娱乐</span>
            <div class="show1">
              <div style="width: 220px; flex-shrink: 0; margin-top: -35px">
                <!-- <span class="content_title">信息</span><br><br>
              <span class="content">短消息</span><br><br>
              <span class="content">彩信</span><br><br>
              <br><br>
              <span class="content_title">流媒体播放</span><br><br>
              <span class="content">文件格式：*.3gp、*.mp4</span><br><br><br><br>
              <span class="content_title">音频</span><br><br>
              <span class="content">降噪：双MIC降噪</span><br><br>
              <span class="content">音效：1. SWS；2. 耳返：&lt;30ms</span><br><br>
              <br><br> -->
                <div
                  v-for="item in phonelist.params.software.entertainment.left"
                  :key="item"
                >
                  <br /><br /><span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <div v-for="i in item.content" :key="i">
                    <span class="content">{{ i }}</span
                    ><br /><br />
                  </div>
                </div>
              </div>
              <div style="margin-left: 130px; width: 450px; margin-top: -35px">
                <!-- <span class="content_title">电子邮件</span><br><br>
              <span class="content">支持（POP3/IMAP/Exchange）</span><br><br>
              <br><br>
              <span class="content_title">多媒体播放</span><br><br>
              <span class="content">音频文件格式：**.mp3、*.mid、*.amr、*.awb、*.3gp、*.mp4、*.m4a、*.aac、*.wav、*.ogg、*.flac、*.mkv</span><br><br>
              <span class="content">视频文件格式：*.3gp、*.mp4、*.webm、*.mkv</span><br><br>
              <span class="content">图片格式：*.png、*.gif （静态）、*.jpg、*.bmp、*.webp、*.wbmp</span><br><br>
              <br><br> -->
                <div
                  v-for="item in phonelist.params.software.entertainment.right"
                  :key="item"
                >
                  <br /><br /><span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <div v-for="i in item.content" :key="i">
                    <span class="content">{{ i }}</span
                    ><br /><br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="wrap">
                <el-divider style="width:1250px"></el-divider>
 
            </div> -->

        <div class="wrap">
          <div class="box">
            <span class="title3">拍摄</span>
            <div class="show1">
              <div style="width: 220px; margin-top: -35px">
                <!-- <span class="content_title">摄像头分辨率</span><br><br>
              <span class="content">后置摄像头：6400万像素（f/1.9光圈）+800万像素+200万像素</span><br><br>
              <span class="content">照片：最大可支持64MP</span><br><br>
              <span class="content">录像：最大可支持1080P</span><br><br>
              <span class="content">副摄像头：1600万像素（f/2.0光圈）</span><br><br>
              <span class="content">照片：最大可支持16MP</span><br><br>
              <span class="content">录像：最大可支持1080P</span><br><br>
              <br><br>
              <span class="content_title">闪光灯</span><br><br>
              <span class="content">前置: 不支持</span><br><br>
              <span class="content">后置: 单色温闪光灯</span><br><br><br><br>
              <span class="content_title">拍照功能</span><br><br>
              <span class="content">跟随软件版本</span><br><br>
              <br><br> -->
                <div
                  v-for="item in phonelist.params.software.camera.left"
                  :key="item"
                >
                  <br /><br /><span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <div v-for="i in item.content" :key="i">
                    <span class="content">{{ i }}</span
                    ><br /><br />
                  </div>
                </div>
              </div>
              <div style="margin-left: 130px; width: 450px; margin-top: -35px">
                <!-- <span class="content_title">视频拍摄</span><br><br>
              <span class="content">后置摄像头：支持1080P视频录制，不支持光学防抖</span><br><br>
              <span class="content">前置摄像头：支持1080P视频录制，不支持光学防抖</span><br><br>
              <br><br>
              <span class="content_title">对焦方式</span><br><br>
              <span class="content">前置：固定焦距</span><br><br>
              <span class="content">后置：PDAF</span><br><br>
              <br><br>
              <span class="content_title">图片与视频</span><br><br>
              <span class="content">图片文件格式：*.jpg</span><br><br>
              <span class="content">视频文件格式：*.mp4</span><br><br>
              <br><br> -->
                <div
                  v-for="item in phonelist.params.software.camera.right"
                  :key="item"
                >
                  <br /><br /><span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <div v-for="i in item.content" :key="i">
                    <span class="content">{{ i }}</span
                    ><br /><br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="wrap">
                <el-divider style="width:1250px"></el-divider>

            </div> -->

        <div class="wrap">
          <div class="box">
            <span class="title3">其他</span>
            <div class="show1">
              <div style="width: 800px; margin-top: -35px">
                <!-- <span class="content_title">传输功能</span><br><br>
              <span class="content">手机作WLAN热点功能</span><br><br>
              <span class="content">WLAN直连(direct)</span><br><br>

              <br><br>
              <span class="content_title">软件升级</span><br><br>
              <span class="content">HOTA软件升级</span><br><br><br><br>
              <span class="content_title">USB功能</span><br><br>
              <span class="content">USB OTG</span><br><br>
              <span class="content">通过USB连接上网</span><br><br>
              <span class="content">USB充电</span><br><br>
              <br><br> -->
                <div
                  v-for="item in phonelist.params.software.other"
                  :key="item"
                >
                  <br /><br /><span class="content_title">{{ item.name }}</span
                  ><br /><br />
                  <div v-for="i in item.content" :key="i">
                    <span class="content">{{ i }}</span
                    ><br /><br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <div style="margin-top: 30px"></div>
    </div>
  </div>
</template>

<script>
import data from "../js/phonelist.json";
import { defineComponent, reactive, onMounted, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  setup() {
    const route = useRoute();
    const state = reactive({
      show1: false,
      show2: false,
      show3: false,
      showDetails: true,
      imgList: [],
      detailList: [],
      stylelist1: [],
      phonelist: {},
      prjid: 0
    });
    onMounted(() => {
      state.prjid = route.params.id;
      if (route.params.id == 1) {
        state.phonelist = data.product1;
      } else if (route.params.id == 2) {
        state.phonelist = data.product2;
      } else if (route.params.id == 3) {
        state.phonelist = data.product3;
      }else if(route.params.id == 4){
        console.log(data.product4)
        state.phonelist = data.product4
      }
      // console.log(state.phonelist);

      state.detailList = state.phonelist.feature.imglist.map(item => ({
        src: require("@/assets" + item)
      }));
      state.imgList = state.phonelist.params.hardware.color.map(item => ({
        name: item.name,
        url: require("@/assets" + item.value)
      }));
    });

    const changePage = () => {
      if (!state.showDetails) {
        state.showDetails = true;
      }
      window.scrollTo(0, 0);
    };

    const changePage1 = () => {
      if (state.showDetails) {
        state.showDetails = false;
      }
      window.scrollTo(0, 0);
    };

    const openshop = url => {
      window.open(url);
    };

    const change1 = () => {
      if (state.show1 == true) {
        state.show1 = false;
      } else {
        state.show1 = true;
      }
    };

    const change2 = () => {
      if (state.show2 == true) {
        state.show2 = false;
      } else {
        state.show2 = true;
      }
    };

    return {
      changePage1,
      changePage,
      openshop,
      change1,
      change2,
      ...toRefs(state)
    };
  }
});
// export default {
//   data() {
//     return {
//       phonelist: {},
//       showDetails: true,
//       // imgList: [],
//       detailList: [],
//       stylelist1: [],
//       show1: false,
//       show2: false,
//       show3: false,
//     };
//   },
//   computed: {
//     imgList() {
//       return this.phonelist.feature.imglist.map((item) => ({
//         src: require("@/assets" + item),
//       }));
//     },
//   },
//   created() {
//     window.console.log(this.$route.path);
// if (this.$route.params.id == 1) {
//   this.phonelist = data.product1;
// } else if (this.$route.params.id == 2) {
//   this.phonelist = data.product2;
// }

// this.detailList = this.phonelist.feature.imglist.map((item) => ({
//   src: require("@/assets" + item),
// }));

//     // this.stylelist1 = this.phonelist.feature.imglist.map(item => (
//     //   {
//     //     backgroundImage: 'url(' + require('@/assets' + item) + ')',
//     //     backgroundSize: '100% 100%',
//     //     backgroundRepeat: "no-repeat",
//     //   }
//     // ))

// this.imgList = this.phonelist.params.hardware.color.map((item) => ({
//   name: item.name,
//   url: require("@/assets" + item.value),
// }));

//     console.log(this.detailList);
//   },

//   methods: {
// changePage() {
//   if (!this.showDetails) {
//     this.showDetails = true;
//   }
//   window.scrollTo(0, 0);
// },
// changePage1() {
//   if (this.showDetails) {
//     this.showDetails = false;
//   }
//   window.scrollTo(0, 0);
// },
// // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// image(url) {
//   // eslint-disable-next-line @typescript-eslint/no-var-requires
//   console.log(require(url));
//   return require(url);
// },

// openshop(url) {
//   window.open(url);
// },

// change1() {
//   if (this.show1 == true) {
//     this.show1 = false;
//   } else {
//     this.show1 = true;
//   }
// },

// change2() {
//   if (this.show2 == true) {
//     this.show2 = false;
//   } else {
//     this.show2 = true;
//   }
// },
//   },
// };
</script>

<style scoped>
.nav_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1300px;
  margin-top: 50px;
  flex-shrink: 0;
  padding-bottom: 10px;
}

/* .change>a:hover{
    border-bottom: 3px solid red;
    padding-bottom:10px

} */

.color {
  font-size: 24px;
  font-style: SourceHanSansSC;

  color: black;
}

.change {
  display: flex;
  justify-content: space-around;
}
.title {
  font-size: 16px;
  font-weight: regular;
  font-style: SourceHanSansSC-bold;

  color: #535353;
  text-decoration: none;
  cursor: pointer;
}

.title_checked {
  font-size: 16px;
  font-weight: bold;
  font-style: SourceHanSansSC-bold;

  color: black;
  text-decoration: none;
  cursor: pointer;
}

.title1 {
  font-size: 20px;
  font-weight: bold;
  font-style: SourceHanSansSC-bold;
  color: black;
}

.content_title {
  font-size: 18px;
  font-style: SourceHanSansSC-bold;
  font-weight: bold;
  color: black;
}

.content {
  font-size: 18px;
  font-style: SourceHanSansSC-bold;

  color: black;
}

.pad {
  padding-top: 60px;
}

.net_content {
  font-size: 16px;
  font-style: SourceHanSansSC-bold;
  color: grey;
}

.box {
  display: flex;
  margin-top: 100px;
  margin-bottom: 100px;
  justify-content: space-between;
  width: 1250px;
  min-width: 900px;
}

.button {
  color: white;
  background-color: #9b001b;
  margin-left: 40%;
  border-radius: 20px;
  width: 110px;
  height: 40px;
  flex-shrink: 0;
  font-size: 20px;
  font-style: Roboto;
  border-style: none;
}

.button1 {
  color: white;
  background-color: transparent;
  border-radius: 20px;
  width: 110px;
  height: 40px;
  flex-shrink: 0;
  font-size: 20px;
  font-style: Roboto;
  border-color: white;
  float: right;
}

.title2 {
  width: 150px;
  flex-shrink: 0;
}

.button_div {
  margin-left: 40vw;
}

.title3 {
  font-size: 28px;
  font-weight: bold;
  font-style: SourceHanSansSC-bold;
  color: black;
  white-space: nowrap;
}

.title4 {
  font-size: 24px;
  font-weight: bold;
  font-style: SourceHanSansSC-bold;
  color: black;
}

.title5 {
  font-size: 36px;
  font-weight: bold;
  font-style: SourceHanSansSC-bold;
  color: black;
}

.content1 {
  font-size: 16px;
  font-style: SourceHanSansSC-bold;

  color: #bebebe;
}

.show1 {
  display: flex;
  margin-top: 0.2vw;
  text-align: left;
}

.wrap {
  display: flex;
  justify-content: center;
}

.wrap1 {
  display: flex;
  justify-content: flex-start;
}

img {
  display: block;
}

.buy_button {
  background-color: #9b001b;
  color: white;
  border-radius: 20px;
  border-style: none;
  width: 100px;
  height: 35px;
  font-size: 16px;
  margin-left: 2vw;
}

.menu {
  position: absolute;
  background-color: white;
  z-index: 2;
  width: 180px;
  right: -40px;
  padding-bottom: 10px;
  padding-top: 10px;
  display: none;
}

.buy:hover .menu {
  position: absolute;
  background-color: white;
  z-index: 2;
  width: 180px;
  right: -40px;
  padding-bottom: 20px;
  display: block;
}

.buy {
  position: relative;
}

.flex {
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: center;
}

.flex:hover {
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: center;

  background-color: #ebeced;
}

.flex1 {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;
}

.flex1:hover {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;

  background-color: #ebeced;
}

.buy_content {
  font-size: 16px;
  font-family: SourceHanSansSC-regular;
  color: black;
  margin-left: 15px;
  letter-spacing: 1px;
}

.buy_content1 {
  font-size: 14px;
  font-family: SourceHanSansSC-regular;
  color: black;
  margin-left: 10px;
  letter-spacing: 1px;
}
</style>
